import { HttpClient } from '../../../services/api/client'
import { TokenManager } from '../../../services/auth/tokenManager'
import type {
  ApiResponse,
  CreateInterviewRequest,
  InterviewRecord,
  UpdateInterviewRequest,
} from '@bandos/shared'

/**
 * CRUD client for interviews scoped to a mindmap. Replaces the old mindmap-save
 * round-trip that used to mutate `node.data.interviewQuestions` in the JSONB.
 */
export class MindmapInterviewService {
  static async list(mindmapId: string): Promise<ApiResponse<{ interviews: InterviewRecord[] }>> {
    const headers = await TokenManager.getAuthHeaders()
    return HttpClient.get<{ interviews: InterviewRecord[] }>(
      `/mindmaps/${mindmapId}/interviews`,
      headers
    )
  }

  static async get(
    mindmapId: string,
    interviewId: string
  ): Promise<ApiResponse<{ interview: InterviewRecord }>> {
    const headers = await TokenManager.getAuthHeaders()
    return HttpClient.get<{ interview: InterviewRecord }>(
      `/mindmaps/${mindmapId}/interviews/${interviewId}`,
      headers
    )
  }

  static async create(
    mindmapId: string,
    body: CreateInterviewRequest
  ): Promise<ApiResponse<{ interview: InterviewRecord }>> {
    const headers = await TokenManager.getAuthHeaders()
    return HttpClient.post<{ interview: InterviewRecord }>(
      `/mindmaps/${mindmapId}/interviews`,
      body,
      headers
    )
  }

  static async update(
    mindmapId: string,
    interviewId: string,
    body: UpdateInterviewRequest
  ): Promise<ApiResponse<{ interview: InterviewRecord }>> {
    const headers = await TokenManager.getAuthHeaders()
    return HttpClient.patch<{ interview: InterviewRecord }>(
      `/mindmaps/${mindmapId}/interviews/${interviewId}`,
      body,
      headers
    )
  }

  static async delete(
    mindmapId: string,
    interviewId: string
  ): Promise<ApiResponse<{ success: true }>> {
    const headers = await TokenManager.getAuthHeaders()
    return HttpClient.delete<{ success: true }>(
      `/mindmaps/${mindmapId}/interviews/${interviewId}`,
      headers
    )
  }
}
